import Vue from 'vue';
import { cognitoMixins } from '@storm/mixins/cognito';

export default Vue.component('storm-login', {
  template: require('./template.html'),
  name: 'storm-login',
  mixins: [cognitoMixins],
  data() {
    return {
      username: '',
      password: '',
      code: '',
      activeForm: 'login',
      error: false,
      codeError: false,
      loading: false,
      firstTime: false,
    };
  },
  methods: {
    async login() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          try {
            this.loading = true;
            this.error = false;
            await this.cognitoLogin({
              username: this.username,
              password: this.password,
            });
            this.$router.push({ path: '/storm-drzzle-accounts' });
          } catch (e) {
            const message = e.message || e;
            this.$log.error(message);
            this.error = message;
            if (e.code === 'UserNotConfirmedException') {
              this.activeForm = 'confirm';
            }
          } finally {
            this.loading = false;
          }
        }
      });
    },
    async confirmUser() {
      this.$validator.validate('code', this.code).then(async (result) => {
        if (result) {
          this.loading = true;
          this.codeError = false;
          try {
            const payload = {
              email: this.username,
              code: this.code,
              password: this.password,
            };
            await this.cognitoConfirmNewUser(payload);
            // try logging user in
            await this.cognitoLogin({
              username: this.username,
              password: this.password,
            });
            this.$router.push({ path: '/storm-drzzle-accounts' });
          } catch (e) {
            const message = e.message || e;
            this.$log.error(message);
            this.codeError = message;
            // if there is a credentials error, we need to show login again
            // to retry
            if (e.code === 'NotAuthorizedException') {
              this.activeForm = 'login';
              this.firstTime = true;
            }
            // if user tries to login for the first time after
            // the 24 hour code expiration, we send a new code
            if (e.code === 'ExpiredCodeException') {
              this.codeError = 'That code is no longer valid. We have sent a new one. Please try again with the new code.';
              await this.cognitoResendNewUserCode({ email: this.username });
            }
          } finally {
            this.loading = false;
          }
        }
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/storm/login/index.js